import React, { useContext, useState } from 'react';
import { ContextProps } from '../types/ContextProps';
import { StowageRuleBM } from 'src/types/BusinessModel/Stowage/StowageRule/StowageRuleBM';
import { StowageRulesMapsBM } from 'src/types/BusinessModel/Stowage/StowageRule/StowageRulesMapsBM';

type StowageRuleContext = {
    setStowageRules: (stowageRules: StowageRuleBM[] | null) => void;
    stowageRules: StowageRuleBM[];
    setStowageRulesMaps: (stowageRulesMaps: StowageRulesMapsBM | null) => void;
    stowageRulesMaps: StowageRulesMapsBM;
};

export const StowageRuleContext = React.createContext<StowageRuleContext>(undefined!);

export const StowageRuleProvider = ({ children }: ContextProps) => {
    const [stowageRules, setStowageRules] = useState<StowageRuleBM[]>([]);
    const [stowageRulesMaps, setStowageRulesMaps] = useState<StowageRulesMapsBM>(null);

    return (
        <StowageRuleContext.Provider
            value={{
                stowageRules,
                setStowageRules,
                stowageRulesMaps,
                setStowageRulesMaps,
            }}
        >
            {children}
        </StowageRuleContext.Provider>
    );
};

export const useStowageRuleStore = () => useContext(StowageRuleContext);
